<template>
    <div class="preguide-container">
            <TitlePart text="Supporting Exhibitors"/>
            <a-row :gutter="[24,24]" class="myrow">
                <a-col :xs="12" :sm="8" :lg="5">
                    <div class="logo-box">
                        <img src="@/assets/sponsors/esri_logo.png" alt="">
                    </div>
                </a-col>
                <a-col :xs="12" :sm="8" :lg="5">
                    <div class="logo-box">
                        <img src="@/assets/sponsors/fce-logo.png" alt="">
                    </div>
                </a-col>
                <a-col :xs="12" :sm="8" :lg="5">
                    <div class="logo-box">
                        <img src="@/assets/sponsors/lsgi-logo.png" alt="">
                    </div>
                </a-col>
            </a-row>
            <TitlePart text=" Call for Sponsors"/>
            <div style="line-height:150%">
                <p class="left-aligned-text" style="line-height:150%; text-align:justify;">We have three levels of packages available with different benefits (see the table below for details). <br>
                    The deadline for confirming participation for the exhibition is Nov 20, 2024. Please contact us for details via email 
                    <a class="mail" href="mailto:">asiacarto@polyu.edu.hk</a> or <a class="mail" href="mailto:">info@asiacarto.org</a>.
                </p>
                <img class="scaled-image" src="@/assets/SponsorsForm0131.png" alt="Call for Sponsors">
                <br>
                <br>
                <p class="underline-text">Payment Methods:</p>
                <li class="left-aligned-text" style="line-height:150%; text-align:justify;">Bank transfer (Please contact <a class="mail" href="mailto:">asiacarto@polyu.edu.hk</a> or <a class="mail" href="mailto:">info@asiacarto.org</a> for details of the bank account)</li>
                <br>
                <p class="underline-text">Registration Policy:</p>
                <li class="left-aligned-text" style="line-height:150%; text-align:justify;">Exhibition confirmation is subject to payment being received.</li>
                <li class="left-aligned-text" style="line-height:150%; text-align:justify;">There will be no refund for cancellation/withdrawal of payment.</li>
            </div>
            <br>
            <br>
            <br>
    </div>
</template>

<script>
import TitlePart from '@/components/TitlePart/TitlePart.vue'
    export default {
        components:{
            TitlePart
        }
    }
</script>

<style lang="less" scoped>
    @import "./style.less" ;
</style>

<style>
.scaled-image {
  max-width: 80%; /* 图片的最大宽度为父容器的宽度 */
  /*max-height: 500px;  图片的最大高度为300像素 */
  width: auto; /* 图片宽度自动调整以保持比例 */
  height: auto; /* 图片高度自动调整以保持比例 */
}
.left-aligned-text {
  text-align: left;
}
</style>